import React from 'react';
import { Modal, ButtonGroup, Button } from 'ui';
import topographicSrc from 'images/topographic.png';
import lessonBuilderSrc from 'images/lesson_builder_with_elearning_section.png';

const ModalContent = ({ closeModal }) => {
  return (
    <>
      <div className="AnnouncementGraphic d-f">
        <img
          alt="Feature Announcement"
          src={topographicSrc}
          className="pos-a AnnouncementGraphic-background-img"
        />

        <img
          alt="Feature Anncouncement"
          src={lessonBuilderSrc}
          className="AnnouncementGraphic-lesson-builder-img"
        />
      </div>
      <Modal.Content className="ScormHasMovedModal-content">
        <div className="lh-28 fz-20 fw-b">
          {t('contents.index.scorm.scorm_has_moved_modal.title')}
          <span role="img" aria-label="Sparkles">
            ✨
          </span>
        </div>
        <div className="lh-24 fz-16 mt-4">
          {t('contents.index.scorm.scorm_has_moved_modal.description')}
        </div>
        <ButtonGroup alignEnd className="ai-c mt-32">
          <Button onClick={closeModal} customColor>
            {t('contents.index.scorm.scorm_has_moved_modal.button')}
          </Button>
        </ButtonGroup>
      </Modal.Content>
    </>
  );
};

const ScormHasMovedModal = ({ visible, closeModal }) => {
  return (
    <Modal
      shown={visible}
      canClickAway
      className="ScormHasMovedModal bg-gray-lightest"
      modalWrapperClassName="ScormHasMovedModal-background"
      onDismiss={closeModal}
      enableFloatingDismiss
    >
      <ModalContent closeModal={closeModal} />
    </Modal>
  );
};

export default ScormHasMovedModal;
